class WishlistPage {
    private container: HTMLElement;

    constructor() {
        const el = document.querySelector('.recommendations-page');
        if (!el) throw new Error('Wishlist container not found');
        this.container = el as HTMLElement;
    }

    /** Clear wishlist, update UI, and reset URL */
    public clear(): void {
        // Remove stored IDs
        localStorage.removeItem('es_wishlist');

        // Replace content
        this.container.innerHTML = '<h2 class="page-title" style="text-align: center; margin: 10vw 0;">Your wishlist is empty.</h2>';

        // Clear wishlist in top bar
        const countElement = document.querySelector<HTMLElement>('.wishlist-count');

        if (countElement) {
            countElement.textContent = '0';
        }

        // Reset URL and top bar wishlist link to /wishlist/
        const baseUrl = `${window.location.origin}/wishlist/`;
        window.history.replaceState({}, '', baseUrl);

        // Select top bar wishlist icon from DOM
        const topBarWishlist = document.querySelector('.wishlist-btn');

        // Update top bar wishlist url
        topBarWishlist?.setAttribute('href', baseUrl);

        // Remove active class from wishlist
        topBarWishlist?.classList.remove('wishlist-active');

    }

}

document.addEventListener('DOMContentLoaded', () => {
    const wishlist = new WishlistPage();
    document.querySelector('.clearwishlist')?.addEventListener('click', () => wishlist.clear());
});
